import { useContext } from 'react';
import { AccountContext, type AccountContextValue } from './accountContext';

/** Profile + business for the signed-in user. Requires `AccountProvider`. */
export function useAccount(): AccountContextValue {
  const value = useContext(AccountContext);
  if (!value) {
    throw new Error('useAccount must be used inside AccountProvider.');
  }
  return value;
}
